import styled from 'styled-components';

/**
 * @since 8.41.0
 */
var TableSortIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TableSortIconWrapper",
  componentId: "c11n-8-107-0__sc-7tgvt6-0"
})([""]);
TableSortIconWrapper.displayName = 'TableSortIconWrapper';

/** @component */
export { TableSortIconWrapper };